enum AUTH_PATHS {
	INDEX = "/",
	REGISTRATION = "/registration",
	REGISTRATION_CHECK_EMAIL = "/send-verification-code",

	GET_ME = "/lk", // +
	PING = "/v1/roles",
	LOGIN = "/auth", // +
	GUEST_LOGIN = "/guest-login",
	TOKEN_REFRESH = "/refresh-token",
	EDIT_EMAIL = "/change-email",

	RECOVERY_PASSWORD_EMAIL = "/password/reset", // +
	RECOVERY_PASSWORD = "/password/restore", // +
	EDIT_PASSWORD = "/v1/users/{uid}/resetpwd",
}

export default AUTH_PATHS;

//POST
// /api/v1/authorization/password-recovery - Восстановление пароля отправка почты
// /api/v1/authorization/new-password  - Восстановление пароля
